import { Expose, Exclude, Type, Transform } from 'class-transformer';
import 'reflect-metadata';
export class List {
  count!: number | null;

  next!: string | null;

  previous!: string | null;
}
